export default __webpack_public_path__ + "static/media/ESRB_E_6.f9a95f70.png";